// extracted by mini-css-extract-plugin
module.exports = {"root":"Attention_root__n2Za_","attention":"Attention_attention__1Ua5U","reduced-attention":"Attention_reduced-attention__WGKzN"};